import { createClient } from "@supabase/supabase-js";

// Environment variables - REQUIRED for app to function
// Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env.local or Vercel
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Fail fast if credentials are missing - don't use placeholders
if (!supabaseUrl || !supabaseAnonKey) {
  const errorMsg = "Missing Supabase credentials. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY environment variables.";
  if (import.meta.env.DEV) {
    console.error(errorMsg);
  }
  // In production, throw to prevent silent failures
  if (import.meta.env.PROD) {
    throw new Error(errorMsg);
  }
}

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
  global: {
    headers: {
      "x-application-name": "dugout",
    },
  },
  db: {
    schema: "public",
  },
});
